module.exports = __webpack_public_path__ + "static/media/Macbook2.8b9a4f25.webp";